var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgOts = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 42,
  height: 42,
  viewBox: "0 0 42 42",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h42v42H0z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4 8)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#F2BB00",
  width: 34,
  height: 26,
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#E6B200",
  x: 3,
  y: 6,
  width: 28,
  height: 18,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M29 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h24ZM17.5 13h-9a1.5 1.5 0 0 0 0 3h9a1.5 1.5 0 0 0 0-3Zm8-6h-17a1.5 1.5 0 0 0 0 3h17a1.5 1.5 0 0 0 0-3Z",
  fill: "#FFD23A"
})))));

export default SvgOts;